import { Component, inject, Input } from '@angular/core';
import { CreatorResponseDto } from '../../../../common/general-types/creators.dto';
import { VideoThumbnailComponent } from '../../../../atoms/video-thumbnail/video-thumbnail.component';
import { VideoFormatEnum } from '../../../../common/general-types/briefs.dto';
import { ImageService } from '../../../../services/image/image.service';
import { FormatService } from '../../../../common/format/format.service';
import { MagicSearchService } from '../../../creators/service/magic-search/magic-search.service';
import { VideoCreatorResponseDto, VideoResponseDto } from '../../../../common/general-types/videos.dto';

export interface PurpleCreatorCardVideo {
  creator: CreatorResponseDto;
  score: number;
  video_file: {
    cover: string;
    s3_bucket: string;
    s3_key: string;
    s3_url: string;
  }
}

@Component({
  selector: 'cv2-creator-card-purple',
  standalone: true,
  imports: [VideoThumbnailComponent],
  templateUrl: './creator-card-purple.component.html',
  styleUrl: './creator-card-purple.component.css'
})
export class CreatorCardPurpleComponent {

  VideoFormatEnum = VideoFormatEnum;
  @Input() creator!: PurpleCreatorCardVideo;

  /** Services */
  private magicSearchService = inject(MagicSearchService);
  public imageService = inject(ImageService);
  public formatService = inject(FormatService);
  /** Services - END */

  videoPreview() {

    let typed_Video: VideoResponseDto = {
      id: "",
      key: this.creator.video_file.s3_key,
      status: 0,
      thumbnail: this.creator.video_file.cover,
      ugcBriefApplicationId: null,
      videoFormat: 0,
      videoLength: 0,
      videoName: "",
      briefApplicationId: "",
      thumbnailURL: this.creator.video_file.cover,
      thumbnailCdnKey: this.creator.video_file.s3_key,
      createdDate: new Date(),
      creator: this.creator.creator ,
      creatorId: this.creator.creator.blazeFirebaseUid || "",
      fullUrl: this.creator.video_file.s3_url,
    }

    this.magicSearchService.previewVideo.set(typed_Video);    
  }

  launchPortfolio() {
    this.magicSearchService.portfolioCreatorId.set(this.creator.creator.blazeFirebaseUid);
    this.magicSearchService.portfolioCreator.set(this.creator.creator);
  }
}
